import { PaymentActivationStatus } from '@core/services/api/interfaces/payment-activation';
import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';
import { ItemDeMenu } from './menu.model';
import { caminhoDaTela, meiosDaTela, podeAbrirMeio } from 'src/app/views/pages/tenant/configuration/payment-activation/recebimentos-access';

const raiz = '/painel/configuracoes/recebimentos';
const filhos = [
  { meio: 'boleto', title: 'Meios de recebimento', permission: TenantPerm.BankSlip_Configure },
  { meio: 'link', title: 'Link de pagamento', permission: TenantPerm.PaymentLinks_Configure },
] as const;

/** Deriva a árvore por sessão; nunca altera o MenuConfig compartilhado. */
export function menuComRecebimentos(itens: ItemDeMenu[], status: PaymentActivationStatus | null): ItemDeMenu[] {
  return itens.map(item => {
    if (item.title !== 'Recebimentos') return item;
    const possuiCredencial = status && [status.boleto, status.pix, status.card].some(item => item.module && item.registered);
    const submenu = status && (status.enrolled || possuiCredencial)
      ? filhos.filter(filho => meiosDaTela(filho.meio).some(meio => podeAbrirMeio(status, meio)
          || (meio !== 'link' && status[meio].module
            && (status[meio].self_service || status[meio].manual_credentials)))).map(filho => ({
          title: filho.title,
          permission: filho.meio === 'boleto'
            ? ['*', filho.permission, TenantPerm.CardReceiving_Configure]
            : ['*', filho.permission],
          page: `${raiz}/${caminhoDaTela(filho.meio)}`,
        }))
      : [];
    return submenu.length ? { ...item, page: raiz, submenu } : { ...item, page: raiz };
  });
}
